/**
 * Main navigation for logged in users
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import Drawer from '@material-ui/core/Drawer';
import classnames from 'classnames';

import NavItems from './NavItems/NavItemsContainer';
import WithSpecifiedTheme from '../../WithSpecifiedTheme/WithSpecifiedTheme';
import { darkTheme } from '../../App/App.theme';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    drawerNav: PropTypes.string.isRequired,
    drawerPaper: PropTypes.string.isRequired,
    staticNav: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.func.isRequired,
  handleNavToggle: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

const defaultProps = {
  className: null,
};

export function UnstyledNav({
  className,
  classes,
  isOpen,
  width,
  isAuthenticated,
  handleNavToggle,
  isAdmin,
}) {
  const isMobile = isWidthDown('sm', width);
  return isMobile ? (
    <Drawer
      className={classnames(className, classes.root, classes.drawerNav)}
      classes={{ paper: classes.drawerPaper }}
      open={isOpen}
      onClose={() => handleNavToggle(false)}
    >
      <NavItems
        className="navList"
        isAuthenticated={isAuthenticated}
        isAdmin={isAdmin}
        handleNavToggle={handleNavToggle}
      />
    </Drawer>
  ) : (
    <NavItems
      className={classnames(className, classes.root, classes.staticNav)}
      isAuthenticated={isAuthenticated}
      isAdmin={isAdmin}
      handleNavToggle={handleNavToggle}
    />
  );
}

UnstyledNav.propTypes = propTypes;
UnstyledNav.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  staticNav: {
    textAlign: 'center',
  },
  drawerNav: {
    '& .navList': {
      padding: 0,
    },
  },
  drawerPaper: {
    position: 'relative',
  },
});

export default withWidth()(WithSpecifiedTheme(darkTheme)(withStyles(styles)(UnstyledNav)));
